"use client";

import { useMemo, useState } from "react";

interface ProductIconProps {
  icon: string;
  className?: string;
  size?: number;
}

/**
 * ProductIcon component that can render either:
 * - Image URLs (from Simple Icons CDN - returns colored PNG/SVG images)
 * - Emoji strings (fallback)
 */
export default function ProductIcon({ icon, className = "", size = 24 }: ProductIconProps) {
  const [imageError, setImageError] = useState(false);
  
  const isUrl = useMemo(() => {
    return icon.startsWith("http://") || icon.startsWith("https://");
  }, [icon]);

  // Render as image for URLs (cdn.simpleicons.org returns colored PNG/SVG images)
  if (isUrl && !imageError) {
    return (
      <img
        src={icon}
        alt=""
        className={className}
        style={{ 
          width: size, 
          height: size,
          objectFit: 'contain',
          flexShrink: 0,
          display: 'block'
        }}
        onError={() => {
          console.warn('Failed to load icon:', icon);
          setImageError(true);
        }}
      />
    );
  }

  // Fallback: Render as emoji/text
  return (
    <span
      className={className}
      style={{ 
        fontSize: size, 
        lineHeight: 1, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      {imageError ? "🔧" : icon}
    </span>
  );
}
